import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { massForceDeleteSkills } from "../../api/apiSkills";
import parseError from "../../utils/parseError";

/**
 * Hook لحذف جماعي نهائي للمهارات
 */
export function useForceDeleteAllSkills() {
    const queryClient = useQueryClient();

    const {
        mutate: forceDeleteAllSkillsMutate,
        isPending,
    } = useMutation({
        mutationFn: massForceDeleteSkills,
        onSuccess: (response) => {
            toast.success(response.message || "Force deleted successfully");
            queryClient.invalidateQueries({ queryKey: ["skills"] });
        },
        onError: (error) => {
            const message = parseError(error);
            toast.error(message || "Failed to force delete skills");
        },
    });

    return {
        forceDeleteAllSkillsMutate,
        isPending,
    };
}